import { render, staticRenderFns } from "./FollowUpWithUs.vue?vue&type=template&id=01476113&scoped=true&"
import script from "./FollowUpWithUs.vue?vue&type=script&lang=js&"
export * from "./FollowUpWithUs.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpWithUs.vue?vue&type=style&index=0&id=01476113&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01476113",
  null
  
)

export default component.exports